import APPCONFIG from '../../../constants/Config';
import {
  REINIT_STATE,
  CPM_GET_ON_DEMAND_ACCESS,
  CPM_SEARCH_ON_DEMAND_ACCESS,
  CPM_SELF_CHECKOUT_ON_DEMAND_ACCESS,
  CPM_EXTEND_ON_DEMAND_ACCESS,
  CPM_PAY_ON_DEMAND_ACCESS_OVERSTAY,
  CPM_UPDATE_ON_DEMAND_ACCESS_CUSTOMER,
  CPM_REFUND_ON_DEMAND_ACCESS,
  CPM_DECLARE_FINAL_EXIT_FOR_TEMPORARY_ON_DEMAND_ACCESS,
} from '../../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import { deserializeForCheckout } from '../../../models/cpm/onDemand';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.cpmOnDemand;
const cpmOnDemand = (state = initialSettings, action) => {
  switch (action.type) {
    // REINIT STATE
    case REINIT_STATE:
      if (action.target === 'cpmOnDemand') {
        return {
          ...state,
          get: { ...initialSettings.get },
          search: { ...initialSettings.search },
          checkout: { ...initialSettings.checkout },
          extend: { ...initialSettings.extend },
          overstay: { ...initialSettings.overstay },
          update: { ...initialSettings.update },
          refund: { ...initialSettings.refund },
          result: null,
        };
      }
      return state;
    // CPM_GET_ON_DEMAND_ACCESS
    case CPM_GET_ON_DEMAND_ACCESS:
      return {
        ...state,
        get: {
          ...state.get,
          loading: true,
          result: null,
        },
      };
    case `${CPM_GET_ON_DEMAND_ACCESS}_ERROR`:
      return {
        ...state,
        get: {
          ...state.get,
          loading: false,
          error: action.error,
        },
      };
    case `${CPM_GET_ON_DEMAND_ACCESS}_SUCCESS`:
      return {
        ...state,
        get: {
          ...state.get,
          loading: false,
          result: deserializeForCheckout(action.data.getOnDemandAccess),
        },
        result: deserializeForCheckout(action.data.getOnDemandAccess),
      };

    // SEARCH_ON_DEMAND_ACCESS
    case CPM_SEARCH_ON_DEMAND_ACCESS:
      return {
        ...state,
        search: {
          ...state.search,
          loading: true,
          error: null,
        },
      };
    case `${CPM_SEARCH_ON_DEMAND_ACCESS}_ERROR`:
      return {
        ...state,
        search: {
          ...state.search,
          error: action.error,
        },
      };
    case `${CPM_SEARCH_ON_DEMAND_ACCESS}_SUCCESS`:
      return {
        ...state,
        search: {
          ...state.search,
          result: deserializeForCheckout(action.data.searchOnDemandAccess),
        },
        result: deserializeForCheckout(action.data.searchOnDemandAccess),
      };

    // SELF_CHECKOUT_ON_DEMAND_ACCESS
    case CPM_SELF_CHECKOUT_ON_DEMAND_ACCESS:
      return {
        ...state,
        checkout: {
          ...state.checkout,
        },
      };
    case `${CPM_SELF_CHECKOUT_ON_DEMAND_ACCESS}_ERROR`:
      return {
        ...state,
        checkout: {
          ...state.checkout,
          error: action.error,
        },
      };
    case `${CPM_SELF_CHECKOUT_ON_DEMAND_ACCESS}_SUCCESS`:
      return {
        ...state,
        checkout: {
          ...state.checkout,
          done: true,
          result: deserializeForCheckout(action.data.selfCheckoutOnDemandAccess),
        },
        result: deserializeForCheckout(action.data.selfCheckoutOnDemandAccess),
      };
    // CPM_EXTEND_ON_DEMAND_ACCESS
    case CPM_EXTEND_ON_DEMAND_ACCESS:
      return {
        ...state,
        extend: {
          ...state.extend,
        },
      };
    case `${CPM_EXTEND_ON_DEMAND_ACCESS}_ERROR`:
      return {
        ...state,
        extend: {
          ...state.extend,
          done: true,
          error: action.error,
        },
      };
    case `${CPM_EXTEND_ON_DEMAND_ACCESS}_SUCCESS`:
      return {
        ...state,
        extend: {
          ...state.extend,
          done: true,
          result: deserializeForCheckout(action.data.extendOnDemandAccess),
        },
        result: deserializeForCheckout(action.data.extendOnDemandAccess),
      };
    // CPM_PAY_ON_DEMAND_ACCESS_OVERSTAY
    case CPM_PAY_ON_DEMAND_ACCESS_OVERSTAY:
      return {
        ...state,
        overstay: {
          ...state.overstay,
        },
      };
    case `${CPM_PAY_ON_DEMAND_ACCESS_OVERSTAY}_ERROR`:
      return {
        ...state,
        overstay: {
          ...state.overstay,
          error: action.error,
        },
      };
    case `${CPM_PAY_ON_DEMAND_ACCESS_OVERSTAY}_SUCCESS`:
      return {
        ...state,
        overstay: {
          ...state.overstay,
          done: true,
          result: deserializeForCheckout(action.data.payOnDemandAccessOverstay),
        },
        result: deserializeForCheckout(action.data.payOnDemandAccessOverstay),
      };

    // CPM_UPDATE_ON_DEMAND_ACCESS_CUSTOMER
    case CPM_UPDATE_ON_DEMAND_ACCESS_CUSTOMER:
      return {
        ...state,
        update: {
          error: null,
          updated: false,
        },
      };
    case `${CPM_UPDATE_ON_DEMAND_ACCESS_CUSTOMER}_ERROR`:
      return {
        ...state,
        update: {
          error: action.error,
          updated: false,
        },
      };
    case `${CPM_UPDATE_ON_DEMAND_ACCESS_CUSTOMER}_SUCCESS`:
      return {
        ...state,
        update: {
          error: null,
          updated: true,
        },
      };

      // CPM_REFUND_ON_DEMAND_ACCESS
    case CPM_REFUND_ON_DEMAND_ACCESS:
      return {
        ...state,
        refund: {
          loading: true,
          error: null,
          refunded: false,
        },
      };
    case `${CPM_REFUND_ON_DEMAND_ACCESS}_ERROR`:
      return {
        ...state,
        refund: {
          loading: false,
          error: action.error,
          refunded: false,
        },
      };
    case `${CPM_REFUND_ON_DEMAND_ACCESS}_SUCCESS`:
      return {
        ...state,
        refund: {
          loading: false,
          error: null,
          refunded: true,
        },
      };

      // CPM_DECLARE_FINAL_EXIT_FOR_TEMPORARY_ON_DEMAND_ACCESS
    case CPM_DECLARE_FINAL_EXIT_FOR_TEMPORARY_ON_DEMAND_ACCESS:
      return {
        ...state,
        declareFinalExit: {
          error: null,
          done: false,
        },
      };
    case `${CPM_DECLARE_FINAL_EXIT_FOR_TEMPORARY_ON_DEMAND_ACCESS}_ERROR`:
      return {
        ...state,
        declareFinalExit: {
          error: action.error,
          done: false,
        },
      };
    case `${CPM_DECLARE_FINAL_EXIT_FOR_TEMPORARY_ON_DEMAND_ACCESS}_SUCCESS`:
      return {
        ...state,
        declareFinalExit: {
          error: null,
          done: true,
        },
      };

    default:
      return state;
  }
};

export default cpmOnDemand;



// WEBPACK FOOTER //
// ./reducers/cpm/onDemand/onDemand.js